import { Directive, HostListener, Input } from "@angular/core";

@Directive({
    selector: '[app-readonly]'
})
export class ReadonlyDirective {
    @Input('app-readonly') enabled: boolean = true;

    @HostListener('click', ['$event']) onClick($event: Event) {
        if(this.enabled === true){
            $event.preventDefault();
            $event.stopPropagation();
        }
    }
}